import React, {Component} from 'react';
import EditableTable from "@components/Table/EditableTable";
import {connect} from "react-redux";
import {api} from "@redux/api";
import {FunctionalFormColumns, functionformProps} from "@containers/management/FunctionalForm/FunctionalFormColumns";
import {FunctionalFormFormFields} from "@containers/management/FunctionalForm/FunctionalFormFields";
import { useAuth, AUTH_LEVEL } from '@/hooks/use-auth';
import { useSmartNavigate } from '@/hooks/use-smart-navigate';


class FunctionalForm extends Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            data: [],
            name: '',
            isLoading: false,
            query: null,
            tableRef: null
        }
    }

    handleCreateFunctionalForm = (body) => {
        return api.createFunctionalFormView(body).then(
            response => {
                // console.log('create', response);
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleDeleteFunctionalForm = (id) => {
        return api.deleteFunctionalFormView(id).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handleBulkDelete = (body) => {
        return api.bulkFunctionalFormView(body).then(
            response => {
                return response.data
            }
        ).catch(error => (
            error
        ));
    }

    handOnlineSave = (key, row) => {
        return api.editFunctionalFormView(key, row).then(
            response => {

                return response
            }
        ).catch(error => (
            error
        ));
    }


    handleFilter = (query) => {

        this.setState({
            isLoading: true,
        });

        return api.filterFunctionalFormView(query).then(
            response => {
                let dataSource = response.data.results
                return {
                    data: dataSource,
                    success: true,
                    total: response.data.count
                }
            }
        ).catch(error => (
            error
        ));
    }

    getFunctionalForm = (data) => {

        this.setState({
            isLoading: false,
            data
        })

    }

    refresh = (needRequest) => {
        return this.tableRef?.current?.refresh(needRequest);
    };

    renderSearches = () => {
    }
    gettableRef = (tableRef) => {
        console.log('tableRef', tableRef)
        this.setState({
            tableRef
        })
    }

    render() {
        return (

            <div>
                <EditableTable
                    ref={this.tableRef}
                    columns={FunctionalFormColumns}
                    data={this.state.data}
                    columnProps={functionformProps}
                    formFields={FunctionalFormFormFields(this.state.tableRef)}
                    getRecord={this.getFunctionalForm}
                    createRecords={this.handleCreateFunctionalForm}
                    deleteRecord={this.handleDeleteFunctionalForm}
                    bulkInsert={this.handleBulkInsert}
                    bulkDelete={this.handleBulkDelete}
                    handOnlineSave={this.handOnlineSave}
                    handleFilter={this.handleFilter}
                    postComment={this.handlePostComment}
                    renderFilter={this.renderFilter}
                    hide_search={true}
                    isRowClickable={false}
                    isRelated={false}
                    isAttachments={false}
                    setFilters={this.setFilters}
                    filterDescription={this.state.filterDescription}
                    getFormRef={this.gettableRef}
                    hide_imports={true}
                    formClassName={'flex-form  '}
                    hid_new={!this.props.canWrite}
                    canDelete={this.props.canFullAccess}
                    onDoubleClick={(record) => {
                        this.props.navigateAndCloseTabs(`/admin/functional-form-detail/${record.id}`, '/admin/functional-form-detail/');
                    }}
                />
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {}
}
const mapDispatchToProps = dispatch => {
    return {}
}

const withHooks = (Component) => {
    const NewComponent = (props) => {
        const canWrite = useAuth('functionform', AUTH_LEVEL.WRITE);
        const canFullAccess = useAuth('functionform', AUTH_LEVEL.FULL_ACCESS);
        const { navigateAndCloseTabs } = useSmartNavigate();
        return <Component {...props} canWrite={canWrite} canFullAccess={canFullAccess} navigateAndCloseTabs={navigateAndCloseTabs} />
    }
    return NewComponent;
}

export default withHooks(connect(
    mapStateToProps,
    mapDispatchToProps
)(FunctionalForm));
